import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { WhitepaperSectionsModel, WhitePapersModel } from 'src/Models/WhitePapersModel';
import { CheckAuth } from 'src/Services/utility.service';
import { WhitePaperService } from 'src/Services/white-paper.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-manage-white-papers',
  templateUrl: './manage-white-papers.component.html',
  styleUrls: ['./manage-white-papers.component.css']
})
export class ManageWhitePapersComponent implements OnInit {
  @ViewChild('FreeModelButton', { static: true }) FreeModelButton: ElementRef;
  popupmsg: string = '';
  whitePapersModel = new WhitePapersModel();
  loginuserID: number = 0;
  productId: number = 1;
  tokenKey: string = '';
  SelectedTool: string;

  whitePaperId: number = 0;
  isMultipleClick: boolean = false;
  file: any;
  isShowprogressSpinner = false;
  blockedDocument = false;
  @ViewChild('fileUpload', { static: true }) fileUpload;
  issubmitted: boolean = false;
  dropdownOptionSettings = {}
  dropdownOptionItems = [];
  listOfOptionSelected = [];
  isSelectExternalURL: boolean = false;
  isSelectFileUpload: boolean = false;
  isErrorOnUploadDoc: boolean = false;
  selectedFiles: File;
  selectedOptionItems = [];
  dropdownListSection = [];
  selectedItemsSections = [];
  dropdownSettingsSections = {};
  selectedSectionItems = [];
  listOfGetWhitepaperSectionData: WhitepaperSectionsModel[];

  constructor(private readonly activedRoute: ActivatedRoute, 
    private readonly router: Router, 
    private readonly checkAuth: CheckAuth, 
    private readonly titleService: Title,
    private readonly whitePaper: WhitePaperService,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('Manage White Papers');
    this.loginuserID = this.sessionStorageService.getAdminUserId();

    this.dropdownOptionSettings = {
      singleSelection: true,
      text: 'Select',
      enableSearchFilter: true,
      classes: 'borderLessTextBoxGreen',
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false
    };
    this.getAllSections();

  }

  // Getter for easy access


  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.FillselectoptionDropdown();
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {

          this.whitePaperId = params['id'];
          this.GetWhitePapersData();
        }
      }
      else
        this.whitePapersModel.isActive = true;
    });
    this.dropdownSettingsSections = {
      singleSelection: true,
      enableSearchFilter: true,
      classes: 'borderLessTextBoxGreen',
      noDataLabel: 'No Section available',
    };

  }

  GetWhitePapersData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.whitePaper.i360WhitePapersFindbyWhitePaperId(this.tokenKey, this.whitePaperId).subscribe(
      data => {
        if (data != null) {
          this.whitePapersModel = data["carrierData"];

          if (this.whitePapersModel.linktype != 0) {
            this.selectedOptionItems = this.dropdownOptionItems.filter(x => x.id == this.whitePapersModel.linktype);
            this.listOfOptionSelected.push(this.whitePapersModel.linktype);
            if (this.whitePapersModel.linktype == 1) {
              document.getElementById('inputfile').style.display = 'none'
              document.getElementById('inputUrl').style.display = 'block'
            }
            else {
              document.getElementById('inputfile').style.display = 'block'
              document.getElementById('inputUrl').style.display = 'none'
            }
          }
          if(this.whitePapersModel.sectionId!=null && this.whitePapersModel.sectionId!=0)
          { 
            if(this.dropdownListSection!=null && this.dropdownListSection.length>0)
            {
              this.selectedItemsSections = this.dropdownListSection.filter(x => x.id == this.whitePapersModel.sectionId); 
            }
            else{
            setTimeout(() => {
          this.selectedItemsSections = this.dropdownListSection.filter(x => x.id == this.whitePapersModel.sectionId); 
          }, 800);
         }
          }

        }
      }, error => {
        this.showMessage(error, 'Error', 'error');
      })
  }

  getAllSections() {
    this.whitePaper.i360WhitepaperSectionListWithIds(this.tokenKey).subscribe(data => {
      if (data['status'] !== 'Failure') {
        for (let iCounter = 0; iCounter < data['sectionList'].length; iCounter++) {
          this.dropdownListSection.push(
            { 'id': data['sectionList'][iCounter].sectionId, 'itemName': data['sectionList'][iCounter].sectionName }
          );
        }
      }
    });
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }


  saveWhitePapers(whitepaperForm) {
    this.issubmitted = true;

    if (this.listOfOptionSelected.length == 0) {
      //this.showMessage('Please Link Type', 'Link Type Required', 'error');
      return;
    }

    if (this.listOfOptionSelected[0] == 2) {
      if (this.fileUpload.nativeElement.files.length == 0 && !this.whitePapersModel.displayDocName) {
        this.showMessage('Please select file', 'File Required', 'error');
        return;
      }
    } else {
      if (whitepaperForm.form.invalid) {
        return false;
      }
    }

    event.preventDefault();

    if (this.whitePapersModel.title == '' || typeof (this.whitePapersModel.title) == 'undefined' || this.whitePapersModel.title == null) {
      this.showMessage('Please enter title', 'Title Required', 'error');
      return;
    }
    if (this.selectedItemsSections == null || this.selectedItemsSections.length == 0){
      this.showMessage('Please enter Section', 'Section Required', 'error');
      return;
      }


    // if (this.fileUpload.nativeElement.files.length == 0 && !this.whitePapersModel.displayDocName) {
    //   this.showMessage('Please select file', 'File Required', 'error');
    //   return;
    // }
    
    if (this.whitePapersModel.sortOrder == '' || typeof (this.whitePapersModel.sortOrder) == 'undefined' || this.whitePapersModel.sortOrder == null) {
      //this.showMessage('Please enter sortOrder', 'SortOrder Required', 'error');
      if(this.whitePapersModel.sortOrder != 0)
      {
      return;
      }
    }


    this.whitePapersModel.createdBy = this.loginuserID;
    this.whitePapersModel.modifiedBy = this.loginuserID;
    let formData = new FormData();
    formData.append('whitePaperId', this.whitePapersModel.whitePaperId);
    formData.append('title', this.whitePapersModel.title);
    formData.append('displayDocName', this.whitePapersModel.displayDocName);
    formData.append('docPath', this.whitePapersModel.docPath);
    formData.append('fileUpload', this.fileUpload.nativeElement.files[0]);
    formData.append('createdBy', this.whitePapersModel.createdBy);
    formData.append('modifiedBy', this.whitePapersModel.modifiedBy);
    formData.append('isActive', this.whitePapersModel.isActive);
    formData.append('isAllowallAccess', this.whitePapersModel.isAllowallAccess);
    formData.append('linktype', this.listOfOptionSelected[0]);
    if(this.whitePapersModel.externalURL!=null && this.whitePapersModel.externalURL!='null')
    {
    formData.append('externalURL', this.whitePapersModel.externalURL);
    }
    formData.append('sortOrder', this.whitePapersModel.sortOrder);
    formData.append('sectionId', this.selectedItemsSections[0].id);


    if (this.isMultipleClick) {
      return;
    }
    this.isMultipleClick = true;
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
    this.whitePaper.i360WhitePapersAddUpdate(this.tokenKey, formData).subscribe(
      data => {
        this.isShowprogressSpinner = false;
        this.blockedDocument = false;
        this.isMultipleClick = false;
        if (data['whitePapersId'] != 0) {
          if (data['whitePapersId'] == -1) {
            this.showMessage('Duplicate record found.', 'Duplicate', 'error');
          }
          else {
            if (this.whitePaperId == 0)
              this.showMessage('Record saved successfully', 'Save', 'success');
            else
              this.showMessage('Record updated successfully', 'Update', 'success');
            this.whitePaperId = 0;
            this.cancelWhitePapers()
          }
        }
      },
      error => {
        this.isMultipleClick = false;
        this.isShowprogressSpinner = false;
        this.blockedDocument = false;
        console.log(error)
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  cancelWhitePapers() {
    this.router.navigate(['admin/jsi360/WhitePaper']);
  }

  IfFreeProduct(event) {
    if (this.whitePaperId > 0) {
      this.FreeModelButton.nativeElement.click();
      this.popupmsg = event ? 'Are you sure you want to allow access to this item to all companies and subscribers having access to White Paper?' : 'Are you sure you want to remove access to this item from all companies and subscribers having access to this White Paper?';
    }
  }

  Cancelpopup() {
    this.GetWhitePapersData();
  }

  FillselectoptionDropdown() {
    this.dropdownOptionItems.push({ "id": '1', "itemName": "External URL" });
    this.dropdownOptionItems.push({ "id": '2', "itemName": "File Upload" });
  }

  onSelectOption($event) {
    this.listOfOptionSelected = [];
    this.listOfOptionSelected.push($event.id);
    if ($event.id == 1) {
      document.getElementById('inputfile').style.display = 'none'
      document.getElementById('inputUrl').style.display = 'block'
    } else if ($event.id == 2) {
      document.getElementById('inputfile').style.display = 'block'
      document.getElementById('inputUrl').style.display = 'none'
    } else {
      document.getElementById('inputfile').style.display = 'none'
      document.getElementById('inputUrl').style.display = 'none'
    }
  }

  onDeselectOption() {
    document.getElementById('inputfile').style.display = 'none'
    document.getElementById('inputUrl').style.display = 'none'
    this.listOfOptionSelected = [];
  }

  onDeselectAllOption() {
    document.getElementById('inputfile').style.display = 'none'
    document.getElementById('inputUrl').style.display = 'none'
    this.listOfOptionSelected = [];
  }

  fileEvent(event): any {
    var file = event.target.files[0];
    let size = Math.round(file.size / 1024);
    if (size <= 21000) {
      var allowedExtensions = ["doc", "DOC", "docx", "DOCX", "pdf", "PDF"];
      let fileType = file.name.split('.').pop();

      if (!this.isInArray(allowedExtensions, fileType)) {
        this.showMessage('You have selected an invalid file type.System supports following file formats: PDF, DOC, DOCX.', 'Error', 'error');
        this.isErrorOnUploadDoc = true;
        window.scrollTo(0, 0);
      }
      else {
        this.isErrorOnUploadDoc = false;
        this.selectedFiles = event.target.files;
      }
    }
    else {
      this.showMessage('You have selected a larger file. supports file upto 20MB.', 'Error', 'error');
      this.isErrorOnUploadDoc = true;
      window.scrollTo(0, 0);
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  onSelectedSection($event) {
    // this.selectedItemsSections = this.removeElemetninArray(this.selectedItemsSections, $event.id)
    // this.selectedItemsSections.push($event.id);
  }
  onDeSelectedSection($event) {
    if (this.selectedItemsSections != null) {
      if (this.selectedItemsSections.length > 0) {
        this.selectedItemsSections = this.removeElemetninArray(this.selectedItemsSections, $event.id)
      }
    }
  }
}
